import { buildScaleMarkers } from './viewUtils'
import { CanvasOverlay } from '../Canvas/CanvasOverlay'
import { usePannableCanvasContext } from '../Canvas/pannableCanvasContext'

export const TimeScale = ({ startMs, endMs }: { startMs: number; endMs: number }) => {
  const { overlayEl, transform } = usePannableCanvasContext()
  const markers = buildScaleMarkers(startMs, endMs, { zoom: transform.zoom })
  const scale = (
    <div className="relative h-9 rounded-md border border-[var(--border)] bg-[var(--control)]">
      {markers.map((marker) => (
        <span
          key={marker.id}
          className="absolute top-0 h-full border-l border-[var(--border)]"
          style={{ left: marker.left }}
        >
          <span className="absolute left-2 top-2 whitespace-nowrap text-[10px] font-black uppercase tracking-wider text-[var(--muted)]">
            {marker.label}
          </span>
        </span>
      ))}
    </div>
  )

  if (overlayEl) {
    return (
      <>
        <div className="h-9" aria-hidden="true" />
        <CanvasOverlay anchor="viewport" className="pannableCanvasTimeScaleOverlay">
          {scale}
        </CanvasOverlay>
      </>
    )
  }

  return scale
}
